import { render, staticRenderFns } from "./product-list.vue?vue&type=template&id=47c986ba&scoped=true"
import script from "./product-list.vue?vue&type=script&lang=js"
export * from "./product-list.vue?vue&type=script&lang=js"
import style0 from "./product-list.vue?vue&type=style&index=0&id=47c986ba&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c986ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47c986ba')) {
      api.createRecord('47c986ba', component.options)
    } else {
      api.reload('47c986ba', component.options)
    }
    module.hot.accept("./product-list.vue?vue&type=template&id=47c986ba&scoped=true", function () {
      api.rerender('47c986ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/budget/budget_fee/form/product-list.vue"
export default component.exports